import { defaultTheme } from 'sletat-ui-components2/dist/theme';
import { cssToObject } from '../../../../utils/cssToObject';
import { LESS_768_MEDIA_QUERY } from '../../../consts/adaptive';

export const styles = {
  containerBlur: {
    position: 'sticky',
    top: 0,
    zIndex: 5,
    boxShadow: '0px 2px 4px rgba(15, 85, 126, 0.04), 0px 8px 8px rgba(18, 102, 152, 0.04);',

    '&::after': {
      content: '""',
      display: 'block',
      height: '100%',
      width: 28,
      position: 'absolute',
      top: 0,
      right: 0,
      background: 'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)',
    },

    '&::before': {
      content: '""',
      display: 'block',
      height: '100%',
      width: 28,
      position: 'absolute',
      top: 0,
      left: 0,
      background: 'linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
    }
  },
  container: {
    backgroundColor: defaultTheme.theme.colorVariables.bgPrimary,
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&::-webkit-scrollbar-thumb': {
      display: 'none',
    },
  },
  menuItem: {
    display: 'flex',
    cursor: 'pointer',
    textAlign: 'center',
    userSelect: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 114,

    '&:first-child': {
      marginLeft: 10,
    },
    '&:last-child': {
      marginRight: 10,
    },
  },
  selectedMenuItem: {
    extend: 'menuItem',
    position: 'relative',

    '&::after': {
      content: '""',
      display: 'block',
      height: 4,
      width: '100%',
      position: 'absolute',
      bottom: 0,
      left: 0,
      backgroundColor: defaultTheme.theme.colorVariables.link,
    }
  },
  menuList: {
    padding: 0,
    margin: '0 auto',
    display: 'flex',
    height: 60,
    listStyle: 'none',
    justifyContent: 'center',
    width: 'max-content',
  },

  link: {
    ...cssToObject(defaultTheme.theme.mixin.fontCaptionM_Caps),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    padding: '16px 12px',
    textDecoration: 'none',
    color: defaultTheme.theme.colorVariables.textDark,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',

    '&:hover': {
      color: defaultTheme.theme.colorVariables.link,
    }
  },

  [LESS_768_MEDIA_QUERY]: {
    container: {
      '&::after': {
        height: 48,
      },
      '&::before': {
        height: 48,
      }
    },

    menuItem: {
      minWidth: 'unset',
    },

    menuList: {
      height: 48,
    },

    selectedMenuItem: {
      extend: 'menuItem',
      minWidth: 'unset',
    },
  },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
